export default __webpack_public_path__ + "static/media/gf-bot-new.e0bb19e7.png";